const FeatureContainer = ({ columnClass, logo, title, details }) => {
  return (
    <div className={columnClass}>
      <div className="import-tile-container ">
        <div className="feature-activity import-tile ">
          <div className="import-tile-header mb-1">
            <img alt="" src={logo} />
            <div className="featrTitl">{title}</div>
          </div>
          <p>{details}</p>
        </div>
      </div>
    </div>
  );
};

export default FeatureContainer;
